import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { InsiderMappingService } from "../../../../../api/services/insider-mapping.service";
import { MessageService } from "primeng/api";
import { sanitizeForm } from "../../../../../core/utils/form-clean";
import {
  handlePasteWithoutLeadingSpaces,
  preventLeadingSpaceKey,
} from "src/core/utils/input-validation.utils";

type FormData = {
  parentCik: string;
  insiderCik: string;
  insiderName: string;
  p2iq: string;
  insiderComment:string
};

// Only string keys of formData
type StringFormDataKeys = {
  [K in keyof FormData]: FormData[K] extends string ? K : never;
}[keyof FormData];
type PasteField = StringFormDataKeys | keyof EditInsiderDataComponent;
@Component({
  selector: "app-edit-insider-data",
  // imports: [],
  templateUrl: "./edit-insider-data.component.html",
  styleUrl: "./edit-insider-data.component.css",
  standalone: false,
})
export class EditInsiderDataComponent implements OnInit {
  formData: any = {
    insiderCik: "",
    insiderId: undefined,
    insiderName: "",
    p2iq: "",
    insiderComment:"",
    reason: "",
    totalCount: "",
  };
  searchInsider: string = "";
  showDropdown = false;
  isLoading: boolean = false;
  filteredInsiders: any[] = [];
  selectedInsider: any = null;
  insiderData: any = null;
  validationErrors = {
    insiderName: "",
  };
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public insiderMappingService: InsiderMappingService,
    public _messageService: MessageService
  ) {}

  ngOnInit(): void {
    if (this.config.data && this.config.data.insiderData) {
      this.insiderData = { ...this.config.data.insiderData };
      this.bindFormData(this.config.data.insiderData);
    }
  }
  private bindFormData(product: any) {
    this.formData = {
      insiderName: product.insiderName || product.asReportedInsiderName || "",
      insiderCik: product.insiderCik || "",
      p2iq: product.p2iq || "",
      insiderComment:product.insiderComment
    };
    // Clear validation errors when form data is bound
    this.validationErrors = {
      insiderName: "",
    };
  }
  onUpdate() {
    // Reset validation errors
    this.validationErrors = {
      insiderName: "",
    };

    // Validate required fields
    let isValid = true;
    if (!this.formData.insiderName || !this.formData.insiderName.trim()) {
      this.validationErrors.insiderName = "Insider Name is required";
      isValid = false;
    }

    if (!isValid) {
      return;
    }

    const payload = {
    ...this.formData,
    insiderName: this.formData.insiderName?.trim() ||this.formData.asReportedInsiderName?.trim()|| "",
    insiderCik: this.formData.insiderCik?.trim() || "",
    p2iq: this.formData.p2iq?.trim() || "",
    reason: "Updated attributes successfully",
    totalCount: this.insiderData.totalCount,
    insiderId: this.insiderData.insiderId,
    insiderComment:this.formData.insiderComment,
    };
    const cleanedForm = sanitizeForm(payload);
    this.isLoading = true;
    this.insiderMappingService.updateInsider(cleanedForm).subscribe({
      next: (updatedInsider) => {
        this._messageService.add({
          severity: "success",
          summary: "Success",
          detail: "Issuer updated successfully.",
        });
      },
      error: (error) => {
        this.isLoading = false;
        console.error("Update failed:", error);
        this._messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Failed to update issuer.",
        });
      },
      complete: () => {
        this.isLoading = false;
        this.ref.close({ refresh: true });
      },
    });
  }

  onCancel() {
    this.ref.close();
  }
  onSearchEnter() {
    const query = this.searchInsider.trim();
    if (query) {
      this.isLoading = true;
      this.insiderMappingService.getInsidersByInsiderName(query).subscribe({
        next: (data) => {
          this.filteredInsiders = data;
          this.showDropdown = data.length > 0;
        },
        error: (err) => {
          this.isLoading = false;
          this._messageService.add({
            severity: "error",
            summary: err.error?.message || "Failed to fetch insiders",
          });
          this.showDropdown = false;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    }
  }

  onInsiderSelect(insider: any) {
    this.selectedInsider = insider;
    this.searchInsider = insider.asReportedInsiderName || "";
    this.showDropdown = false;
    insider.insiderName = insider.asReportedInsiderName;
    this.bindFormData(insider);
  }
  preventSpaceKey(event: KeyboardEvent): void {
    preventLeadingSpaceKey(event);
  }
  // One universal paste handler for ALL fields
  onPaste(event: ClipboardEvent, field: PasteField): void {
    handlePasteWithoutLeadingSpaces(event, (newValue: string) => {
      if (field in this.formData) {
        // @ts-ignore
        this.formData[field as StringFormDataKeys] = newValue;
      } else {
        // @ts-ignore
        (this as any)[field] = newValue;
      }
    });
  }
}
